import PropTypes from "prop-types";

const ProgressRing = ({ className = "", color, percentage, size, strokeWidth, trackColor = null }) => {
  const value = Math.min(Math.max(Number(percentage) || 0, 0), 100);
  const center = size / 2;
  const radius = (size - strokeWidth) / 2;

  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={`tw-flex-none tw-pointer-events-none tw--rotate-90 ${className}`}
    >
      {trackColor && (
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke={trackColor}
          strokeWidth={strokeWidth}
        />
      )}
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        pathLength={100}
        strokeDasharray={`${value} 100`}
        className={`tw-transition-[stroke-dasharray,stroke,opacity] tw-duration-500 tw-ease-out motion-reduce:tw-transition-none ${
          value > 0 ? "tw-opacity-100" : "tw-opacity-0"
        }`}
      />
    </svg>
  );
};

ProgressRing.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string.isRequired,
  percentage: PropTypes.number.isRequired,
  size: PropTypes.number.isRequired,
  strokeWidth: PropTypes.number.isRequired,
  trackColor: PropTypes.string,
};

export default ProgressRing;
